import { render } from "./MyCards.vue?vue&type=template&id=29acf9d0&scoped=true"
import script from "./MyCards.vue?vue&type=script&lang=js"
export * from "./MyCards.vue?vue&type=script&lang=js"

import "./MyCards.vue?vue&type=style&index=0&id=29acf9d0&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29acf9d0"]])

export default __exports__